import { render, staticRenderFns } from "./SettingsArticlesPage.vue?vue&type=template&id=6111594e"
import script from "./SettingsArticlesPage.vue?vue&type=script&lang=js"
export * from "./SettingsArticlesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports